// extracted by mini-css-extract-plugin
export default {"quantity_container":"BH","hiddenflavorstring":"CH","loadingLine":"EH","productimgwrap":"FH","productimg":"GH","circlepic":"HH","productinfo":"IH","grey_x":"JH","cartrow":"KH","bold":"LH","title":"MH","blue":"NH","strike":"OH","flexgap":"PH","flavorstring":"QH","nodecorate":"RH","flavorstring_link":"SH","rdstring":"TH","removeditemblock":"UH","removed_heading":"VH","removed_text":"WH","addback":"XH"};
    if(module.hot) {
      // 1738836197030
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  